import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogComponent } from '../../../shared/dialog.component';
import { SessionService } from '../session.service';
import { JhiEventManager } from '../../../ng-jhipster/service';
import { AccountService } from '../../../core/auth/account.service';
import { UserService } from '../../../core/user/user.service';
import { Router } from "@angular/router";
import * as i0 from "@angular/core";
import * as i1 from "../../../core/auth/account.service";
import * as i2 from "../../../core/user/user.service";
import * as i3 from "@angular/router";
import * as i4 from "@ng-bootstrap/ng-bootstrap";
import * as i5 from "../session.service";
import * as i6 from "../../../ng-jhipster/service";
import * as i7 from "@fortawesome/angular-fontawesome";
import * as i8 from "@angular/common";
import * as i9 from "@angular/forms";
import * as i10 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i11 from "../../../shared/alert/alert-error.component";
import * as i12 from "@angular/material/radio";
import * as i13 from "@angular/material/form-field";
import * as i14 from "@angular/material/input";
import * as i15 from "@ngx-translate/core";
const _c0 = function (a0) { return { threshold: a0 }; };
function CancelSessionDialogComponent_form_3_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "p", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiTranslate", ctx_r6.confirmationText)("translateValues", i0.ɵɵpureFunction1(2, _c0, ctx_r6.region.cancellationThreshold / 60));
} }
function CancelSessionDialogComponent_form_3_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "p", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiTranslate", ctx_r7.confirmationText);
} }
function CancelSessionDialogComponent_form_3_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵelement(3, "h3", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "jhi-alert-error");
    i0.ɵɵtemplate(5, CancelSessionDialogComponent_form_3_div_1_div_5_Template, 2, 4, "div", 4);
    i0.ɵɵtemplate(6, CancelSessionDialogComponent_form_3_div_1_div_6_Template, 2, 1, "div", 4);
    i0.ɵɵelementStart(7, "div", 13);
    i0.ɵɵelement(8, "p", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("jhiTranslate", ctx_r2.confirmationHeader);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.isUser && ctx_r2.region != null && ctx_r2.isLessThanThreshold);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.isUser);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("jhiTranslate", ctx_r2.confirmationQuestion);
} }
function CancelSessionDialogComponent_form_3_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelementStart(2, "button", 18);
    i0.ɵɵelement(3, "span", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 17);
    i0.ɵɵelementStart(5, "button", 19);
    i0.ɵɵlistener("click", function CancelSessionDialogComponent_form_3_div_2_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(2); return ctx_r8.cancel(); });
    i0.ɵɵelement(6, "span", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("jhiTranslate", ctx_r3.confirmationButton);
} }
function CancelSessionDialogComponent_form_3_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵelementStart(2, "button", 23);
    i0.ɵɵlistener("click", function CancelSessionDialogComponent_form_3_div_3_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); return ctx_r10.cancel(); });
    i0.ɵɵelement(3, "span", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 24);
    i0.ɵɵelement(5, "span", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("jhiTranslate", ctx_r4.confirmationButton);
} }
function CancelSessionDialogComponent_form_3_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "button", 25);
    i0.ɵɵlistener("click", function CancelSessionDialogComponent_form_3_div_4_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.reschedule(ctx_r12.sessionId); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CancelSessionDialogComponent_form_3_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 5);
    i0.ɵɵlistener("ngSubmit", function CancelSessionDialogComponent_form_3_Template_form_ngSubmit_0_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.confirm(ctx_r14.sessionId, ctx_r14.type); });
    i0.ɵɵtemplate(1, CancelSessionDialogComponent_form_3_div_1_Template, 9, 4, "div", 6);
    i0.ɵɵtemplate(2, CancelSessionDialogComponent_form_3_div_2_Template, 7, 1, "div", 7);
    i0.ɵɵtemplate(3, CancelSessionDialogComponent_form_3_div_3_Template, 6, 1, "div", 8);
    i0.ɵɵtemplate(4, CancelSessionDialogComponent_form_3_div_4_Template, 2, 0, "div", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.confirmationHeader && ctx_r0.confirmationText && ctx_r0.confirmationQuestion);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.confirmationButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.confirmationButton);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.type === "cancel");
} }
function CancelSessionDialogComponent_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelement(1, "h3", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiTranslate", ctx_r16.cancelHeader);
} }
function CancelSessionDialogComponent_div_4_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 27);
    i0.ɵɵelementStart(2, "mat-radio-button", 36);
    i0.ɵɵelement(3, "span", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 27);
    i0.ɵɵelementStart(5, "mat-radio-button", 38);
    i0.ɵɵelement(6, "span", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 27);
    i0.ɵɵelementStart(8, "mat-radio-button", 40);
    i0.ɵɵelement(9, "span", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 27);
    i0.ɵɵelementStart(11, "mat-radio-button", 42);
    i0.ɵɵelement(12, "span", 43);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CancelSessionDialogComponent_div_4_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 27);
    i0.ɵɵelementStart(2, "mat-radio-button", 44);
    i0.ɵɵelement(3, "span", 45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 27);
    i0.ɵɵelementStart(5, "mat-radio-button", 46);
    i0.ɵɵelement(6, "span", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 27);
    i0.ɵɵelementStart(8, "mat-radio-button", 48);
    i0.ɵɵelement(9, "span", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CancelSessionDialogComponent_div_4_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 50);
    i0.ɵɵelementStart(1, "mat-form-field", 51);
    i0.ɵɵelementStart(2, "mat-label");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "textarea", 52);
    i0.ɵɵlistener("ngModelChange", function CancelSessionDialogComponent_div_4_div_10_Template_textarea_ngModelChange_5_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(2); return ctx_r20.otherReason = $event; });
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, "sessionChat.radio.type"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(6, 5, "sessionChat.radio.type"));
    i0.ɵɵproperty("ngModel", ctx_r19.otherReason);
} }
function CancelSessionDialogComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CancelSessionDialogComponent_div_4_div_1_Template, 2, 1, "div", 26);
    i0.ɵɵelementStart(2, "div", 27);
    i0.ɵɵelement(3, "p", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-radio-group", 29);
    i0.ɵɵlistener("ngModelChange", function CancelSessionDialogComponent_div_4_Template_mat_radio_group_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(); return ctx_r22.cancelReason = $event; });
    i0.ɵɵtemplate(5, CancelSessionDialogComponent_div_4_div_5_Template, 13, 0, "div", 4);
    i0.ɵɵtemplate(6, CancelSessionDialogComponent_div_4_div_6_Template, 10, 0, "div", 4);
    i0.ɵɵelementStart(7, "div", 27);
    i0.ɵɵelementStart(8, "mat-radio-button", 30);
    i0.ɵɵlistener("click", function CancelSessionDialogComponent_div_4_Template_mat_radio_button_click_8_listener() { i0.ɵɵrestoreView(_r23); const ctx_r24 = i0.ɵɵnextContext(); return ctx_r24.showOtherReasonInput = true; });
    i0.ɵɵelement(9, "span", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, CancelSessionDialogComponent_div_4_div_10_Template, 7, 7, "div", 32);
    i0.ɵɵelementStart(11, "div", 33);
    i0.ɵɵelementStart(12, "button", 34);
    i0.ɵɵlistener("click", function CancelSessionDialogComponent_div_4_Template_button_click_12_listener() { i0.ɵɵrestoreView(_r23); const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.submitCancelReason(); });
    i0.ɵɵelement(13, "span", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.cancelHeader);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r1.cancelReason);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.isUser);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r1.isUser);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.showOtherReasonInput);
} }
export class CancelSessionDialogComponent extends DialogComponent {
    constructor(accountService, userService, router, activeModal, sessionService, eventManager, modalService) {
        super(activeModal);
        this.accountService = accountService;
        this.userService = userService;
        this.router = router;
        this.sessionService = sessionService;
        this.eventManager = eventManager;
        this.modalService = modalService;
        this.cancelled = false;
        this.modalOptions = { windowClass: 'modal-window', size: 'sm' };
        this.showOtherReasonInput = false;
        this.isLessThanThreshold = false;
    }
    ngOnInit() {
        this.userService.current().subscribe(user => {
            this.isUser = this.accountService.isUser();
            this.isCoach = this.accountService.isCoach();
            this.isCustomerCare = this.accountService.isCustomerCare();
            this.confirmationText = this.isUser ? 'sessionChat.paragraph.' + this.type + 'SessionThreshold' : 'sessionChat.paragraph.' + this.type + 'SessionCoach';
            this.cancelHeader = this.isUser ? 'sessionChat.messages.titleCancel' : 'sessionChat.messages.titleCancelCoach';
        });
        this.sessionService.getSession(this.sessionId).subscribe((session) => {
            this.session = session.body;
            this.userService.getRegionObjectByName(this.session.user.region).subscribe(region => {
                this.region = region;
                this.calculateLessThanThreshold();
            });
        }, (err) => { console.log(err); });
        this.confirmationHeader = 'sessionChat.header.' + this.type;
        this.confirmationQuestion = 'sessionChat.paragraph.' + this.type + 'Session';
        this.confirmationButton = 'sessionChat.button.' + this.type + 'Yes';
    }
    confirm(id, type) {
        if (type === 'cancel') {
            this.sessionService.cancelSession(id).subscribe(() => {
                this.cancelled = true;
                this.eventManager.broadcast('sessionListModification');
                this.eventManager.broadcast('sessionCanceled');
                if (this.selectedConversation) {
                    this.eventManager.broadcast({ name: 'selectedConversationChanged', content: this.session.user.id });
                    this.sessionService.futureControl(this.selectedConversation.user.id).subscribe(res => {
                        console.log(res.body);
                        if (res.body != null && res.body.length > 0 && res.body[0] != null) {
                            this.eventManager.broadcast({ name: 'customerCareInfoUpdated', content: res.body[0].sessionStartTime });
                        }
                        else {
                            this.eventManager.broadcast({ name: 'customerCareInfoUpdated', content: null });
                        }
                    });
                }
            });
        }
        else if (type === 'reschedule') {
            this.modalService.dismissAll();
            this.isUser ? this.router.navigate(['../../../../session/schedule-session/' + 'update/' + id]).then() : this.reschedule(id);
        }
    }
    reschedule(id) {
        if (this.isCoach)
            this.eventManager.broadcast('rescheduleForCoach');
        if (this.isCustomerCare) {
            this.eventManager.broadcast('sessionListModification');
            this.eventManager.broadcast({ name: 'selectedConversationChanged', content: this.session.user.id });
            this.eventManager.broadcast({ name: 'rescheduleForCustomerCare', content: this.session.id });
        }
        this.modalService.dismissAll();
    }
    submitCancelReason() {
        let reason;
        if (this.cancelReason === 'OTHER_REASON') {
            reason = this.otherReason != null ? this.otherReason : 'No reason';
        }
        else {
            reason = this.cancelReason;
        }
        this.sessionService.addCancellationReason(reason, this.sessionId).subscribe((res) => console.log(res.body), (err) => console.log(err));
        this.modalService.dismissAll();
    }
    calculateLessThanThreshold() {
        const minutesLeftToSessionStart = this.session.minutesLeftToSessionStart;
        const threshold = this.region.cancellationThreshold;
        this.isLessThanThreshold = minutesLeftToSessionStart < threshold;
    }
    cancelCancelReason() {
        if (this.cancelled) {
            this.cancelReason = 'OTHER_REASON';
            this.otherReason = 'No reason';
            this.submitCancelReason();
        }
        this.activeModal.dismiss();
    }
}
CancelSessionDialogComponent.ɵfac = function CancelSessionDialogComponent_Factory(t) { return new (t || CancelSessionDialogComponent)(i0.ɵɵdirectiveInject(i1.AccountService), i0.ɵɵdirectiveInject(i2.UserService), i0.ɵɵdirectiveInject(i3.Router), i0.ɵɵdirectiveInject(i4.NgbActiveModal), i0.ɵɵdirectiveInject(i5.SessionService), i0.ɵɵdirectiveInject(i6.JhiEventManager), i0.ɵɵdirectiveInject(i4.NgbModal)); };
CancelSessionDialogComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CancelSessionDialogComponent, selectors: [["cancel-session-dialog"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 5, vars: 2, consts: [[1, "olha-theme"], ["icon", "times-circle", 1, "close", 3, "click"], [1, "main-body"], ["name", "deleteForm", 3, "ngSubmit", 4, "ngIf"], [4, "ngIf"], ["name", "deleteForm", 3, "ngSubmit"], ["class", "modal-body", 4, "ngIf"], ["class", "d-sm-none", 4, "ngIf"], ["class", "d-flex justify-content-end", 4, "ngIf"], ["class", "text-center", 4, "ngIf"], [1, "modal-body"], [1, "header"], [1, "mb-3", 3, "jhiTranslate"], [1, "font-weight-bold"], [3, "jhiTranslate"], [3, "jhiTranslate", "translateValues"], [1, "d-sm-none"], [1, "text-center"], ["type", "submit", 1, "btn", "btn-primary"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary", 3, "click"], ["jhiTranslate", "sessionChat.word.no"], [1, "d-flex", "justify-content-end"], [1, "d-none", "d-sm-block", "d-md-block", "d-lg-block", "d-xl-block"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary", "justify-content-center", 3, "click"], ["type", "submit", "id", "confirm-cancel-session-btn", 1, "btn", "btn-primary", "justify-content-center"], ["jhiTranslate", "sessionSchedule.header.rescheduleSession", 1, "btn", "btn-link", 3, "click"], ["class", "header", 4, "ngIf"], [1, "text-div"], ["jhiTranslate", "sessionChat.paragraph.letUsKnow"], [3, "ngModel", "ngModelChange"], ["value", "OTHER_REASON", 3, "click"], ["jhiTranslate", "sessionChat.radio.Other reason"], ["class", "d-flex flex-column", 4, "ngIf"], [1, "d-flex", "justify-content-center"], ["type", "button", "id", "submit-cancel-reason-btn", 1, "btn", "btn-primary", 3, "click"], ["jhiTranslate", "sessionChat.button.submit"], ["value", "I_HAD_AN_UNEXPECTED_URGENT_MEETING"], ["jhiTranslate", "sessionChat.radio.I had an unexpected urgent meeting"], ["value", "I_DID_NOT_HAVE_THE_ENERGY_FOR_A_SESSION_AT_THIS_TIME"], ["jhiTranslate", "sessionChat.radio.I did not have the energy for a session at this time"], ["value", "I_AM_NOT_SURE_THE_COACH_CAN_HELP_ME"], ["jhiTranslate", "sessionChat.radio.I am not sure the coach can help me"], ["value", "I_FOUND_OTHER_SUPPORT"], ["jhiTranslate", "sessionChat.radio.I found other support"], ["value", "CLIENT_ASKED_ME_TO"], ["jhiTranslate", "sessionChat.radio.Client asked me to"], ["value", "I_GOT_SICK"], ["jhiTranslate", "sessionChat.radio.I got sick"], ["value", "I_SCHEDULED_THIS_BY_ACCIDENT"], ["jhiTranslate", "sessionChat.radio.I scheduled this by accident"], [1, "d-flex", "flex-column"], ["appearance", "outline"], ["matInput", "", 3, "ngModel", "placeholder", "ngModelChange"]], template: function CancelSessionDialogComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "fa-icon", 1);
        i0.ɵɵlistener("click", function CancelSessionDialogComponent_Template_fa_icon_click_1_listener() { return ctx.cancelCancelReason(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, CancelSessionDialogComponent_form_3_Template, 5, 4, "form", 3);
        i0.ɵɵtemplate(4, CancelSessionDialogComponent_div_4_Template, 14, 5, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.cancelled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.cancelled);
    } }, directives: [i7.FaIconComponent, i8.NgIf, i9.ɵNgNoValidate, i9.NgControlStatusGroup, i9.NgForm, i10.JhiTranslateDirective, i11.AlertErrorComponent, i12.MatRadioGroup, i9.NgControlStatus, i9.NgModel, i12.MatRadioButton, i13.MatFormField, i13.MatLabel, i14.MatInput, i9.DefaultValueAccessor], pipes: [i15.TranslatePipe], styles: [".main-body[_ngcontent-%COMP%]{padding:30px 30px 20px 30px}.close[_ngcontent-%COMP%]{color:gray;font-size:20px;cursor:pointer;padding:10px}.modal-body[_ngcontent-%COMP%]{padding:0}button[_ngcontent-%COMP%]{margin:5px;height:36px}.btn[_ngcontent-%COMP%]{padding-left:0;padding-right:0}.btn-primary[_ngcontent-%COMP%]{width:150px}.btn-secondary[_ngcontent-%COMP%]{width:76px;min-width:70px}.customer-support[_ngcontent-%COMP%]{color:#44a38b;text-decoration:underline;margin-top:20px;cursor:pointer}.text-div[_ngcontent-%COMP%]{text-align:left;font-weight:normal;margin-top:8px;margin-bottom:8px;font-size:16px !important}[_nghost-%COMP%]  .mat-radio-button, [_nghost-%COMP%]  .mat-form-field{font-family:\"Open Sans\",sans-serif !important}[_nghost-%COMP%]  .mat-radio-button.mat-accent .mat-radio-inner-circle, [_nghost-%COMP%]  .mat-radio-button.mat-accent .mat-radio-ripple .mat-ripple-element:not(.mat-radio-persistent-ripple), [_nghost-%COMP%]  .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-persistent-ripple, [_nghost-%COMP%]  .mat-radio-button.mat-accent:active .mat-radio-persistent-ripple{background-color:#44a38d}[_nghost-%COMP%]  .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle, [_nghost-%COMP%]  .mat-radio-outer-circle{border-color:#44a38d}[_nghost-%COMP%]  .mat-form-field-appearance-outline .mat-form-field-outline{color:#8a9d98 !important}[_nghost-%COMP%]  .mat-form-field-appearance-outline .mat-form-field-outline-thick{color:#44a38d !important}"] });
